import { render, staticRenderFns } from "./activity-watch-list.vue?vue&type=template&id=7f5e355d&"
import script from "./activity-watch-list.vue?vue&type=script&lang=js&"
export * from "./activity-watch-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports